import React from "react";
import { Routes, Route } from "react-router-dom";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";
import { RouteTransition } from "./RouteTransition";

import HomePage from "../pages/HomePage";
import ServicesPage from "../pages/ServicesPage";
import CustomerJourneyPage from "../pages/CustomerJourneyPage";
import PricingPage from "../pages/PricingPage";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import StorePage from "../pages/StorePage";
import SmartReachPage from "../pages/SmartReachPage";
import FootTrafficPage from "../pages/FootTrafficPage";
import LoyaltyPage from "../pages/LoyaltyPage";
import HowItWorksPage from "../pages/HowItWorksPage";
import MeasurementPage from "../pages/MeasurementPage";
import IndustriesPage from "../pages/IndustriesPage";
import IndustryDetailPage from "../pages/IndustryDetailPage";
import AdsManagerPage from "../pages/AdsManagerPage";
import RestaurantsSolutionPage from "../pages/solutions/RestaurantsSolutionPage";
import RetailSolutionPage from "../pages/solutions/RetailSolutionPage";
import EntertainmentSolutionPage from "../pages/solutions/EntertainmentSolutionPage";
import BlogIndexPage from "../pages/blog/BlogIndexPage";
import BlogPostPage from "../pages/blog/BlogPostPage";

import {
  DSPOverviewPage,
  DSPHowItWorksPage,
  DSPPricingPage,
  DSPFAQPage,
  DSPGetAccessPage
} from "../pages/DSPPages";

/**
 * Public site shell — keeps the marketing nav/footer visible. Used for every
 * non-admin route. Lives in its own component so admin routes can render a
 * completely different layout (no public nav/footer/scroll-to-top behaviour).
 */
export const PublicSite = () => (
  <>
    <ScrollToTop />
    <Navigation />
    <RouteTransition>
      <Routes>
        <Route path="/" element={<AdsManagerPage />} />
        <Route path="/overview" element={<HomePage />} />
        <Route path="/ads-manager" element={<AdsManagerPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/customer-journey" element={<CustomerJourneyPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/store" element={<StorePage />} />

        <Route path="/smartreach" element={<SmartReachPage />} />
        <Route path="/foot-traffic-marketing" element={<FootTrafficPage />} />
        <Route path="/loyalty-platform" element={<LoyaltyPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/measurement" element={<MeasurementPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/industries/:slug" element={<IndustryDetailPage />} />

        <Route path="/solutions/restaurants" element={<RestaurantsSolutionPage />} />
        <Route path="/solutions/retail" element={<RetailSolutionPage />} />
        <Route path="/solutions/entertainment" element={<EntertainmentSolutionPage />} />

        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        <Route path="/dsp" element={<DSPOverviewPage />} />
        <Route path="/dsp/how-it-works" element={<DSPHowItWorksPage />} />
        <Route path="/dsp/pricing" element={<DSPPricingPage />} />
        <Route path="/dsp/faq" element={<DSPFAQPage />} />
        <Route path="/dsp/get-access" element={<DSPGetAccessPage />} />
      </Routes>
    </RouteTransition>
    <Footer />
  </>
);
